import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/sorting-warehouse/stats',
)({
    component: () => (
        <LotStatsPage
            kind="sorting"
            title={m.nav_sorting_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="sorting_lots.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_grade()}
        />
    ),
})
